import React from "react";
import CloudScapeSpinner from "@cloudscape-design/components/spinner";

const LoadingSpinner = () => <CloudScapeSpinner size="big" />;

export default LoadingSpinner;
